export default "__VITE_ASSET__10d13a31__"